<template>
  <div class="grid gap-3 md:grid-cols-2 xl:grid-cols-3">
    <slot />
  </div>
</template>
